import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Localized } from '../../../objects';

@Injectable()
export class ServiceDateTypeService {

  private cache: ServiceDateType[];

constructor(private apiSvc: ApiService) { }

public loadEntites(): Promise<ServiceDateType[]> {

  const p = new Promise<ServiceDateType[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("ServiceDateType cache detected");
        resolve(this.cache);
        return;
      }

    this.apiSvc.get("api/servicedateType/", null).subscribe(
      (data: ServiceDateType[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
      },
      (err) => {
        console.log("error", err);
        reject(err);
      }
    );

  });

  return p;

  }

}

export class ServiceDateType {
  Id: string;
  DisplayOrder: number;
  Localized: Localized[];
}

